import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { C } from '../../albumColors';
import { VISIBLE_TOTAL } from '../../albumData';

function RankingCard({ allUsers, theme }) {
  const { t } = useTranslation();
  const ranked = useMemo(
    () => [...allUsers].sort((a, b) => b.owned - a.owned).slice(0, 5),
    [allUsers]
  );

  const headingText = theme?.cardHeadingText ?? C.onSurfaceVariant;
  const bodyText    = theme?.cardBodyText    ?? C.onSurface;
  const subtleText  = theme?.cardSubtleText  ?? C.outline;
  const rankText    = theme?.cardSubtleText  ?? C.outlineVariant;
  const trackBg     = theme?.progressTrack   ?? `${C.outlineVariant}33`;

  if (ranked.length === 0) return null;

  return (
    <section className="mb-8">
      <h4 className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: headingText }}>
        {t('Top coleccionistas')}
      </h4>
      <div className="space-y-3">
        {ranked.map((user, i) => {
          const pct = Math.round((user.owned / VISIBLE_TOTAL) * 100);
          return (
            <div key={user.id} className="flex items-center gap-3">
              <span className="text-[10px] font-black w-4 text-center" style={{ color: rankText }}>
                {i + 1}
              </span>
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
                style={{ backgroundColor: user.color }}
              >
                {user.initial}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-bold truncate" style={{ color: bodyText }}>{user.name}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <div className="h-1 flex-1 rounded-full overflow-hidden" style={{ backgroundColor: trackBg }}>
                    <div className="h-full rounded-full" style={{ backgroundColor: user.color, width: `${pct}%` }} />
                  </div>
                  <span className="text-[9px] font-bold" style={{ color: subtleText }}>{user.owned}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default RankingCard;
